<template>
  <v-footer dark padless>
    <v-card flat tile width="100%" class="grey darken-4 white--text text-center">

    <v-card-text>
    
    </v-card-text>

      

      <v-card-text class="white--text pt-0">
         Copyright &copy; {{ new Date().getFullYear() }} Cookation.com
      </v-card-text>

      <v-card-text>
        <v-btn
          v-for="icon in icons"
          :key="icon"
          class="mx-4 white--text"
          icon
        >
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
    data: () => ({
      icons: [
        'mdi-facebook',
        'mdi-twitter',
        'mdi-google-plus',
        'mdi-linkedin',
        'mdi-instagram',
      ],
    }),
  }
</script>